import { BodyXsXs } from '@constants/text.ts';
import styled from 'styled-components';

export const PathwayCellWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`;

export const PathwayMeta = styled(BodyXsXs)`
    color: var(--colors-text-on-disabled, #70768d);
`;
